
































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as _ from 'lodash';

@Component
export default class SearchTransfer extends Vue {
  @Prop({ required: true, default: () => null }) data!: Array<any> | null;
  @Prop({ required: true, default: () => null }) selected!: Array<any> | null;
  @Prop({ required: true }) search!: (search: string) => Promise<void>;
  @Prop({ required: true }) moveIn!: (item: any) => Promise<void>;
  @Prop({ required: true }) moveOut!: (item: any) => Promise<void>;
  @Prop({ default: () => '12rem' }) listWidth!: string;
  @Prop({ default: () => (item: any) => item.id }) getId!: (item: any) => any;
  @Prop({ default: () => (item: any) => item.title }) getTitle!: (item: any) => string;
  @Prop() getTooltip: ((item: any) => string) | undefined;

  searchValue = '';
  searching = false;
  searchChange!: (value: string) => void;

  operating = false;
  leftChecked: any | null = null;
  rightChecked: any | null = null;

  created() {
    this.searchChange = _.debounce((value: string) => {
      this.searching = true;
      this.search(value).finally(() => {
        this.searching = false;
      });
    }, 200);
  }

  isSelected(item: any) {
    const itemId = this.getId(item);
    if (this.selected) {
      return this.selected.findIndex(x => this.getId(x) === itemId) > -1;
    }
    return false;
  }

  selectLeft(item: any) {
    if (this.leftChecked === item) {
      this.leftChecked = null;
    } else if (!this.isSelected(item)) {
      this.leftChecked = item;
      this.rightChecked = null;
    }
  }

  selectRight(item: any) {
    if (this.rightChecked === item) {
      this.rightChecked = null;
    } else {
      this.leftChecked = null;
      this.rightChecked = item;
    }
  }

  moveToLeft() {
    if (this.rightChecked) {
      this.operating = true;
      this.moveOut(this.rightChecked)
        .then(() => {
          this.rightChecked = null;
        })
        .finally(() => (this.operating = false));
    }
  }

  moveToRight() {
    if (this.leftChecked) {
      this.operating = true;
      this.moveIn(this.leftChecked)
        .then(() => {
          this.leftChecked = null;
        })
        .finally(() => (this.operating = false));
    }
  }
}
